/* EDUARD-CUSTOM
   Pfeile und "Mehr lesen" fuer den Bewertungs-Slider
   (sections/eduard-reviews-slider.liquid).

   Eigenes Custom Element statt eduard-product-slider.js mitzubenutzen:
   Wuerde diese Sektion jenes Skript ein zweites Mal einbinden, liefe dasselbe
   klassische Skript auf einer Seite zweimal - die Klassendeklaration waere
   dann doppelt und der zweite Durchlauf braeche mit einem Fehler ab.

   Das Wischen selbst macht CSS (scroll-snap). Ohne JavaScript bleibt der
   Slider bedienbar - dann fehlen nur die Pfeile, und lange Bewertungen
   stehen vollstaendig da statt geklemmt. Lieber lang als halb. */

class EduardReviewsSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-ers-track]');
    if (!this.track) return;

    this.nav = this.querySelector('[data-ers-nav]');
    this.prev = this.querySelector('[data-ers-prev]');
    this.next = this.querySelector('[data-ers-next]');

    this.onScroll = this.onTrackScroll.bind(this);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });

    if (this.prev) this.prev.addEventListener('click', () => this.move(-1));
    if (this.next) this.next.addEventListener('click', () => this.move(1));

    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
    } else {
      window.addEventListener('resize', this.onScroll);
    }

    this.setupMore();
    this.update();
  }

  disconnectedCallback() {
    if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
    if (this.observer) this.observer.disconnect();
    window.removeEventListener('resize', this.onScroll);
    if (this.mq && this.onMq) {
      if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
      else if (this.mq.removeListener) this.mq.removeListener(this.onMq);
    }
  }

  /* ---- Mehr lesen ------------------------------------------------------ */

  /* Wie viele Zeilen gelten gerade? Handy und Desktop sind getrennt
     einstellbar, 0 heisst: gar nicht klemmen. */
  clampLines() {
    const desktop = parseInt(this.dataset.clamp || '0', 10) || 0;
    const mobile = parseInt(this.dataset.clampMobile || '0', 10) || 0;
    return window.matchMedia('(max-width: 749px)').matches ? mobile : desktop;
  }

  buttonFor(quote) {
    return quote.parentElement ? quote.parentElement.querySelector('[data-ers-more]') : null;
  }

  setupMore() {
    this.quotes = Array.prototype.slice.call(this.querySelectorAll('[data-ers-quote]'));
    if (!this.quotes.length) return;

    this.quotes.forEach((q) => {
      const btn = this.buttonFor(q);
      if (btn && !btn.dataset.bound) {
        btn.dataset.bound = '1';
        btn.addEventListener('click', () => this.toggle(q, btn));
      }
    });

    this.applyClamp();

    /* Webfonts aendern den Zeilenumbruch - nach dem Laden noch einmal messen,
       sonst steht der Knopf an einer Karte, die gar nicht abgeschnitten ist. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => this.applyClamp());
    }

    this.mq = window.matchMedia('(max-width: 749px)');
    this.onMq = () => this.applyClamp();
    if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
    else if (this.mq.addListener) this.mq.addListener(this.onMq);
  }

  applyClamp() {
    if (!this.quotes) return;
    const lines = this.clampLines();

    this.quotes.forEach((q) => {
      const btn = this.buttonFor(q);
      const card = q.closest('.ers__card');

      if (card) card.classList.remove('ers__card--open');
      q.classList.remove('ers__quote--clamped');
      q.style.removeProperty('-webkit-line-clamp');
      if (btn) {
        btn.hidden = true;
        btn.textContent = btn.dataset.more || '';
        btn.setAttribute('aria-expanded', 'false');
      }

      if (!lines) return;

      q.style.setProperty('-webkit-line-clamp', String(lines));
      q.classList.add('ers__quote--clamped');

      /* Den Knopf gibt es nur, wo wirklich etwas abgeschnitten wird. Passt der
         Text in die erlaubten Zeilen, wird die Klemme wieder entfernt. */
      if (q.scrollHeight - q.clientHeight > 1) {
        if (btn) btn.hidden = false;
      } else {
        q.classList.remove('ers__quote--clamped');
        q.style.removeProperty('-webkit-line-clamp');
      }
    });

    this.slidFrom = null;
    this.syncOpenState();
    this.update();
  }

  toggle(quote, btn) {
    const card = quote.closest('.ers__card');
    if (!card) return;
    const open = card.classList.toggle('ers__card--open');
    btn.textContent = open ? (btn.dataset.less || '') : (btn.dataset.more || '');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');

    /* Wischposition merken: daran erkennt onTrackScroll, dass die Karte
       verlassen wurde. */
    this.slidFrom = open ? this.track.scrollLeft : null;
    this.syncOpenState();
    this.update();
  }

  /* Solange etwas offen ist, waechst nur die aufgeklappte Karte - siehe
     .ers--has-open in der CSS-Datei. */
  syncOpenState() {
    this.classList.toggle('ers--has-open', !!this.querySelector('.ers__card--open'));
  }

  closeAll() {
    this.slidFrom = null;
    if (!this.quotes) return;
    this.quotes.forEach((q) => {
      const card = q.closest('.ers__card');
      if (!card || !card.classList.contains('ers__card--open')) return;
      card.classList.remove('ers__card--open');
      const btn = this.buttonFor(q);
      if (btn) {
        btn.textContent = btn.dataset.more || '';
        btn.setAttribute('aria-expanded', 'false');
      }
    });
    this.syncOpenState();
  }

  /* Wer zur naechsten Karte wischt, laesst die aufgeklappte hinter sich -
     dann soll sie sich auch wieder schliessen. Die Schwelle von 24 px
     trennt das Wischen vom Zittern beim Antippen und von den paar Pixeln,
     die das Aufklappen selbst verschieben kann. */
  onTrackScroll() {
    if (this.slidFrom != null && Math.abs(this.track.scrollLeft - this.slidFrom) > 24) {
      this.closeAll();
    }
    this.update();
  }

  /* ---- Pfeile ---------------------------------------------------------- */

  slides() {
    return Array.prototype.slice.call(this.track.querySelectorAll('[data-ers-slide]'));
  }

  /* Eine Kartenbreite plus Abstand - aus dem Layout gelesen, nicht geraten,
     damit die Einstellungen aus dem Theme-Editor automatisch gelten. */
  step() {
    const slide = this.track.querySelector('[data-ers-slide]');
    if (!slide) return this.track.clientWidth;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return Math.round(slide.getBoundingClientRect().width + gap) || this.track.clientWidth;
  }

  offsetOf(slide) {
    return Math.round(
      slide.getBoundingClientRect().left -
      this.track.getBoundingClientRect().left +
      this.track.scrollLeft
    );
  }

  /* Ziel ueber den Kartenindex statt ueber scrollBy: bei schnellen Klicks
     oder einer unterbrochenen Animation bleibt der Slider sonst zwischen
     zwei Karten stehen. */
  move(direction) {
    const slides = this.slides();
    if (!slides.length) return;
    const index = Math.round(this.track.scrollLeft / this.step()) + direction;
    const bounded = Math.max(0, Math.min(index, slides.length - 1));
    this.track.scrollTo({ left: this.offsetOf(slides[bounded]), behavior: 'smooth' });
  }

  update() {
    if (!this.track) return;
    const max = this.track.scrollWidth - this.track.clientWidth;
    const scrollable = max > 2;
    if (this.nav) this.nav.hidden = !scrollable;
    if (this.prev) this.prev.disabled = !scrollable || this.track.scrollLeft <= 2;
    if (this.next) this.next.disabled = !scrollable || this.track.scrollLeft >= max - 2;
  }
}

if (!customElements.get('eduard-reviews-slider')) {
  customElements.define('eduard-reviews-slider', EduardReviewsSlider);
}